export default "__VITE_ASSET__Cg0nGxLY__"